/**
 * Created by Kieran on 16/05/2017.
 */

/** Gets user
 *
 * @type {{dashboard: ((context, mode))}}
 */


import UserApi from "../../api/User";
import ProviderApi from "../../api/Provider"
import _ from "lodash"
import AuthenticationManager from "../AuthenticationManager";


let UserManager = {
  store(context, user) {
    let self = context;
    self.$store.commit('setUser', user);
    self.$nextTick(function () {
      self.$forceUpdate();
      self.$EventBus.$emit('App:localUserUpdate', user);
    })
  },
  getUserAndStore(context) {
    let self = context;
    let getData = UserApi.getUser();
    getData.then(function (response) {
      UserApi.onBoardingStatus()
        .then(function (response) {
          self.$store.commit('setOnBoardingStatus', response.data);
        });

      ProviderApi.getProvider().then(function (response) {
        self.$store.commit('setProvider', response.data);
      });

      self.$store.commit('setUser', response.data);
      self.user = self.$store.state.user;
      if (_.includes(AuthenticationManager.parseJwt().scope, 'standard_tasks')) {
        self.$store.commit('setPaymentStatus', true);
      }

      self.loading = false;
      self.$forceUpdate();
      self.$EventBus.$emit('App:localUserUpdate', self.user);
    }).catch(function (error) {
    })
  },
  get(context) {
    let self = context;
    if (_.has(self, 'settingsUpdating')) {
      if (self.settingsUpdating === true) {
        let getData = UserApi.getUser();
        getData.then(function (response) {
          self.$store.commit('setUser', response.data);
          self.user = self.$store.state.user;
          self.settingsUpdating = false;
          this.getUserAndStore(self)
          self.$forceUpdate();
        });
      }
    }
    if (self.$store.state.user.scope !== undefined) {
      self.user = self.$store.state.user;
    }
    else {
      this.getUserAndStore(context)
    }
  }
};
export default UserManager



// WEBPACK FOOTER //
// ./src/helpers/UserManager/index.js